import React, { useContext } from "react";
import PropTypes from "prop-types";
import UserPrefsContext from "../../../context/UserPrefs/UserPrefsContext";

import Select from "../../shared/InputElements/Select";
import { useIntl } from 'react-intl';

const SelectPurchaseMethod = ({
  id = "select-purchase-method",
  ...rest
}) => {
  const intl = useIntl()
  const userPrefs = useContext(UserPrefsContext);
  const label = intl.formatMessage({ id: "ev.purchaseMethod", defaultMessage: "Purchase Method"})

  return (
    <Select
      id={id}
      value={userPrefs.get("purchaseMethod")}
      label={label}
      optionNames={[intl.formatMessage({ id: "ev.cash", defaultMessage: "Cash"}), intl.formatMessage({ id: "ev.loan", defaultMessage: "Loan"}), intl.formatMessage({ id: "ev.lease", defaultMessage: "Lease"})]}
      optionValues={["cash", "loan", "lease"]}
      handler={e => userPrefs.set({ purchaseMethod: e.target.value })}
      isSpecial
    />
  );
};

export default SelectPurchaseMethod;

SelectPurchaseMethod.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  tooltip: PropTypes.string
};
